import { Datum } from '@/domain/navigation/benachrichtigungen/components/details/shared/Datum';
import { DetailWrapper } from '@/domain/navigation/benachrichtigungen/components/details/shared/DetailWrapper';
import { Personalfragebogen } from '@/domain/navigation/benachrichtigungen/types/Personalfragebogen';

export default function PersonalfragebogenDetail({
  benachrichtigung,
}: {
  benachrichtigung: Personalfragebogen;
}) {
  return (
    <DetailWrapper
      mitarbeiter={benachrichtigung.mitarbeiter}
      footer={
        <span className="whitespace-break-spaces">
          {`Erstellt am: `}
          <Datum von={benachrichtigung.erstellungsDatum} />
          {` um ${benachrichtigung.erstellungsDatum.format('HH:mm')} Uhr`}
        </span>
      }
    />
  );
}
